import { RootState } from 'store';
import { IClientsResponse } from 'types';

export const getClientsSelector = (store: RootState): IClientsResponse | null => store.clients.data || null;

export const getClientsIsLoadingSelector = (store: RootState): boolean => store.clients.isLoading;
